var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-tooltip',{attrs:{"position":_vm.position,"multiline":_vm.size},scopedSlots:_vm._u([{key:"html",fn:function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]},proxy:true}])},[_vm._v(" "),_c('t-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }